import React, { useEffect, useState } from "react";
import Input from "../shared/Input";
import topTost from "../../utils/topTost";
import { useLocation } from "react-router-dom";
import { fetchData, fetchFormData } from "../../utils/options";
import { IBaseUrl } from "../..";
import Swal from "sweetalert2";

const ProfileContent = (permission) => {
  const location = useLocation();
  const queryParams = new URLSearchParams(location.search);
  const M_id = queryParams.get("id");
  const userId = localStorage.getItem("id");

  const [companyformData, setCompanyFormData] = useState({
    id: "1",
    Name: "",
    OthorizedPerson: "",
    MobileNo: "",
    Email: "",
    GST: "",
    GST2: "",
    Pencard: "",
    State: "",
    City: "",
    Address: "",
    Pincode: "",
    TinNumber: "",
    bankHolder: "",
    AccountNo: "",
    Branch: "",
    IFSCCode: "",
    BankName: "",
    OthorizedSignature: "",
    TermAndCondition: "",
    SignImage: "",
  });

  const [isSubmitting, setIsSubmitting] = useState(false);

  const [photoPreview, setPhotoPreview] = useState(null);
  const [signPreview, setSignPreview] = useState(null);
  const handleChange = (name, value) => {
    setCompanyFormData({ ...companyformData, [name]: value });
  };

  const handlePhotoChange = (e) => {
    const file = e.target.files?.[0];

    if (file) {
      const reader = new FileReader();
      setCompanyFormData((prev) => ({ ...prev, photo: file }));
      reader.onloadend = () => {
        setCompanyFormData({
          ...companyformData,
          image: file,
          imageBase64: reader.result,
        });
      };

      reader.onloadend = () => {
        setPhotoPreview(reader.result);
      };
      reader.readAsDataURL(file);
    } else {
      // If file is removed or canceled
      setCompanyFormData((prev) => ({ ...prev, OthorizedSignature: null }));
      setPhotoPreview(null);
    }
  };

  const handleSignChange = (e) => {
    const file = e.target.files?.[0];

    if (file) {
      const reader = new FileReader();
      setCompanyFormData((prev) => ({ ...prev, SignImage: file }));
      reader.onloadend = () => {
        setCompanyFormData({
          ...companyformData,
          SignImage: file,
          imageBase64: reader.result,
        });
      };
      reader.onloadend = () => {
        setSignPreview(reader.result);
      };
      reader.readAsDataURL(file);
    } else {
      // If file is removed or canceled
      setCompanyFormData((prev) => ({ ...prev, SignImage: null }));
      setSignPreview(null);
    }
  };

  const fetchDetails = async () => {
    try {
      Swal.fire({
        title: "Loading...",
        allowOutsideClick: false,
        didOpen: () => Swal.showLoading(),
      });

      const formData = new FormData();
      formData.append("id", 1);
      formData.append("userId", userId);
      formData.append("moduleId", M_id);

      const result = await fetchFormData(
        "company-configuration/getbyid",
        formData,
        "POST"
      );

      if (result && result.data) {
        setCompanyFormData(result.data);
        setPhotoPreview(result.data.OthorizedSignature);
        setSignPreview(result.data.SignImage);
      } else {
        console.warn("data not found.");
        setCompanyFormData({});
      }
    } catch (error) {
      console.error("Failed to fetch:", error);
      setCompanyFormData({});
    } finally {
      Swal.close();
    }
  };

  useEffect(() => {
    fetchDetails();
  }, []);

  const handleSubmit = async (e) => {
    e.preventDefault();
    setIsSubmitting(true);

    try {
      const formData = new FormData();
      formData.append("id", 1);
      formData.append("userId", userId);
      formData.append("moduleId", M_id);
      formData.append("Name", companyformData.Name);
      formData.append("OthorizedPerson", companyformData.OthorizedPerson);
      formData.append("MobileNo", companyformData.MobileNo);
      formData.append("Email", companyformData.Email);
      formData.append("GST", companyformData.GST);
      formData.append("GST2", companyformData.GST2);
      formData.append("Pencard", companyformData.Pencard);
      formData.append("State", companyformData.State);
      formData.append("City", companyformData.City);
      formData.append("Address", companyformData.Address);
      formData.append("Pincode", companyformData.Pincode);
      formData.append("TinNumber", companyformData.TinNumber);
      formData.append("bankHolder", companyformData.bankHolder);
      formData.append("AccountNo", companyformData.AccountNo);
      formData.append("Branch", companyformData.Branch);
      formData.append("IFSCCode", companyformData.IFSCCode);
      formData.append("BankName", companyformData.BankName);
      if (
        companyformData.OthorizedSignature &&
        companyformData.OthorizedSignature instanceof File
      ) {
        formData.append(
          "OthorizedSignature",
          companyformData.OthorizedSignature
        );
      }
      if (
        companyformData.SignImage &&
        companyformData.SignImage instanceof File
      ) {
        formData.append("SignImage", companyformData.SignImage);
      }
      formData.append("TermAndCondition", companyformData.TermAndCondition);

      const result = await fetchFormData(
        "company-configuration/update",
        formData
      );
      if (result.success || result.code === 200) {
        topTost({
          title: result.message,
          icon: "success",
        });
      } else {
        throw new Error("Update failed");
      }
    } catch (error) {
      console.error("Error updating company profile:", error);
      topTost({ title: "Failed to update profile", icon: "error" });
    } finally {
      setIsSubmitting(false);
    }
  };

  return (
    <div className="col-lg-12">
      <div className="card stretch stretch-full">
        <hr className="mt-0" />
        <div className="card-body general-info">
          <div className="mb-5 d-flex align-items-center justify-content-between">
            <h5 className="fw-bold mb-0 me-4">
              <span className="d-block mb-2">Company Information</span>
            </h5>
          </div>

          <form onSubmit={handleSubmit} className="row g-3">
            {/* Row 1 */}
            <div className="col-md-4">
              <Input
                label="Name"
                name="Name"
                value={companyformData.Name}
                onChange={handleChange}
                icon="feather-home"
                required
              />
            </div>
            <div className="col-md-4">
              <Input
                label="Authorized Person"
                name="OthorizedPerson"
                value={companyformData.OthorizedPerson}
                onChange={handleChange}
                icon="feather-shield"
                required
              />
            </div>
            <div className="col-md-4">
              <Input
                label="Mobile Number"
                name="MobileNo"
                value={companyformData.MobileNo}
                onChange={handleChange}
                icopn="feather-smartphone"
                required
              />
            </div>

            {/* Row 2 */}
            <div className="col-md-4">
              <Input
                label="Email"
                name="Email"
                value={companyformData.Email}
                onChange={handleChange}
                icon="feather-mail"
              />
            </div>
            <div className="col-md-4">
              <Input
                label="GST"
                name="GST"
                value={companyformData.GST}
                onChange={handleChange}
                icon="feather-hash"
              />
            </div>
            <div className="col-md-4">
              <Input
                label="GST 2"
                name="GST2"
                value={companyformData.GST2}
                onChange={handleChange}
                icon="feather-hash"
              />
            </div>

            {/* Row 3 */}
            <div className="col-md-4">
              <Input
                label="PAN Card"
                name="Pencard"
                value={companyformData.Pencard}
                onChange={handleChange}
                icon="feather-credit-card"
              />
            </div>
            <div className="col-md-4">
              <Input
                label="State"
                name="State"
                value={companyformData.State}
                onChange={handleChange}
                icon="feather-globe"
              />
            </div>
            <div className="col-md-4">
              <Input
                label="City"
                name="City"
                value={companyformData.City}
                onChange={handleChange}
                icon="feather-map-pin"
              />
            </div>

            {/* Row 4 */}
            <div className="col-md-4">
              <Input
                label="Address"
                name="Address"
                value={companyformData.Address}
                onChange={handleChange}
                icon="feather-map-pin"
              />
            </div>
            <div className="col-md-4">
              <Input
                label="Pincode"
                name="Pincode"
                value={companyformData.Pincode}
                onChange={handleChange}
                icon="feather-hash"
              />
            </div>
            <div className="col-md-4">
              <Input
                label="TIN Number"
                name="TinNumber"
                value={companyformData.TinNumber}
                onChange={handleChange}
                icon="feather-file-text"
              />
            </div>

            {/* Row 5 */}
            <div className="col-md-4">
              <Input
                label="Bank Holder Name"
                name="bankHolder"
                value={companyformData.bankHolder}
                onChange={handleChange}
                icon="feather-user"
              />
            </div>
            <div className="col-md-4">
              <Input
                label="Account Number"
                name="AccountNo"
                value={companyformData.AccountNo}
                onChange={handleChange}
                icon="feather-file-text"
              />
            </div>
            <div className="col-md-4">
              <Input
                label="Branch"
                name="Branch"
                value={companyformData.Branch}
                onChange={handleChange}
                icon="feather-map"
              />
            </div>
            {/* Row 6 */}
            <div className="col-md-4">
              <Input
                label="IFSC Code"
                name="IFSCCode"
                value={companyformData.IFSCCode}
                onChange={handleChange}
                icon="feather-clipboard"
              />
            </div>
            <div className="col-md-4">
              <Input
                label="Bank Name"
                name="BankName"
                value={companyformData.BankName}
                onChange={handleChange}
                icon="feather-briefcase"
              />
            </div>
            <div className="col-md-4">
              <Input
                label="Terms & Conditions"
                name="TermAndCondition"
                value={companyformData.TermAndCondition}
                onChange={handleChange}
                icon="feather-plus-square"
              />
            </div>
            <div className="col-md-4">
              <Input
                label="Logo Image"
                name="OthorizedSignature"
                type="file"
                // value={companyformData.OthorizedSignature}
                onChange={handlePhotoChange}
                icon="feather-edit"
              />
            </div>
            {photoPreview && (
              <img
                src={photoPreview}
                alt="Preview"
                style={{ width: "100px", height: "100px" }}
              />
            )}

            {/* Row 7 */}

            <div className="col-md-4">
              <Input
                label="Company Image"
                name="handleSignChange"
                type="file"
                // value={companyformData.SignImage}
                onChange={handleSignChange}
                icon="feather-edit"
              />
            </div>
            {signPreview && (
              <img
                src={signPreview}
                alt="Preview"
                style={{ width: "100px", height: "100px" }}
              />
            )}
            {/* Submit */}
            <div className="customButton">
              <button type="submit" className="btn btn-lg btn-primary">
                Update
              </button>
            </div>
          </form>
        </div>
      </div>
    </div>
  );
};

export default ProfileContent;
